import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import { StyledTextField } from "shared/dist/components";
import { mailingAddressFormData } from "./content";
import Checkbox from "@mui/material/Checkbox";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { organizationActions } from "../../../../../Services/Redux/actionCreators";
import classes from "./CompanyAddress.module.css";

const stateSelector = (state) => ({
    sameMailingAddress: state.organization.orgAddress.sameMailingAddress,
    hqAddress: state.organization.orgAddress.hqAddress,
    mailingAddress: state.organization.orgAddress.mailingAddress,
});

const MailingAddress = () => {
    const { sameMailingAddress, hqAddress, mailingAddress } = useSelector(
        stateSelector,
        shallowEqual
    );
    const { street, apartment, city, zip, country } = mailingAddress;
    const dispatch = useDispatch();

    const handleMailingAddressChange = (event) => {
        const { name, value } = event.target;
        dispatch(organizationActions.setOrgMailingAddressDetail(name, value));
    };

    const handleSameAddressChange = (event) => {
        const { checked } = event.target;
        dispatch(organizationActions.setOrgSameMailingAddress(checked));
    };

    return (
        <Grid item xs={12} sm={12} md={6} lg={6} className={classes.mailingAddressContainer}>
            <Typography variant="subtitle1">Company Mailing Address (Optional)</Typography>
            <FormControlLabel
                control={
                    <Checkbox
                        name="sameMailingAddress"
                        checked={sameMailingAddress}
                        onChange={handleSameAddressChange}
                        color="primary"
                    />
                }
                label="Same as Registered Address"
                className={classes.checkbox}
            />
            <StyledTextField
                {...mailingAddressFormData.STREET}
                disabled={sameMailingAddress}
                variant="outlined"
                value={sameMailingAddress ? hqAddress.street : street}
                onChange={handleMailingAddressChange}
                fullWidth
            />
            <StyledTextField
                {...mailingAddressFormData.APARTMENT}
                disabled={sameMailingAddress}
                variant="outlined"
                value={sameMailingAddress ? hqAddress.apartment : apartment}
                onChange={handleMailingAddressChange}
                fullWidth
            />
            <StyledTextField
                {...mailingAddressFormData.CITY}
                disabled={sameMailingAddress}
                variant="outlined"
                value={sameMailingAddress ? hqAddress.city : city}
                onChange={handleMailingAddressChange}
                fullWidth
            />
            <Grid container className={classes.doubleField}>
                <Grid item xs={12} sm={12} md={4} lg={4} className={classes.postalCode}>
                    <StyledTextField
                        {...mailingAddressFormData.ZIP}
                        disabled={sameMailingAddress}
                        variant="outlined"
                        value={sameMailingAddress ? hqAddress.zip : zip}
                        onChange={handleMailingAddressChange}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8}>
                    <StyledTextField
                        {...mailingAddressFormData.COUNTRY}
                        disabled={sameMailingAddress}
                        variant="outlined"
                        value={sameMailingAddress ? hqAddress.country : country}
                        onChange={handleMailingAddressChange}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default MailingAddress;
